export default {
  common: {
    email: 'Email',
    password: 'Password',
    edit: 'Modificare',
    update: 'Aggiornare',
    cancel: 'Annullare',
    delete: 'Cancellare'
  },
  home: {
    logout: 'Scollegamento'
  },
  auth: {
    notRegistered: 'Non sei ancora registrato?',
    forgotPassword: 'Ho perso la mia password',
    forgotPasswordContent: 'Inserisci la tua email GOWOD, ti verrà inviata una password temporanea che ti permetterà di accedere.\nNon dimenticare di cambiarla dalle impostazioni dell\'applicazione.',
    localstorageError: 'Sembra che i cookie siano bloccati sul tuo browser. Questo sito li utilizza solo per la memorizzazione dei dati di autenticazione, si prega di abilitare i cookie.',
    signIn: 'Connessione',
    modal: {
      title: 'La registrazione a GOWOD viene effettuata dall\'applicazione mobile',
      content: 'L\'applicazione è disponibile per Android e iOS'
    },
    signinFacebook: "Connessione con Facebook",
    signinGoogle: "Connessione con Google",
  },
  tabs: {
    profile: 'Profilo',
    pdata: 'Dati personali',
    premium: 'GOWOD Premium',
    gifts: 'carte regalo'
  },
  profile: {
    firstname: 'Nome',
    lastname: 'Cognome',
    age: 'Età',
    sex: 'Sesso',
    affiliate: 'Affiliato',
    country: 'Paese',
    birthdate: 'Data di nascita'
  },
  sex: {
    MALE: 'Uomo',
    FEMALE: 'Donna',
    OTHER: 'Altro'
  },
  pdata: {
    title: 'I dati personali raccolti da BUONO per il suo corretto funzionamento sono:',
    part1: 'Dati del profilo: cognome, nome, età, sesso, casella e paese di appartenenza',
    part2: 'Risultati dei test di mobilità: risposte, punteggi, profilo configurato',
    part3: 'I protocolli generati per l\'uso statistico: data, durata selezionata, tipo (pre/post WOD, giornaliero) e i movimenti selezionati',
    manage: 'GESTIONE DEI DATI',
    download: 'Scarica i miei dati',
    delete: 'Elimina il mio account',
    deleteModal: {
      title: 'Eliminazione dell\'account GOWOD',
        part1: 'Sei sicuro di voler eliminare il tuo account GOWOD?',
        part2: 'Questa azione cancellerà il tuo account così',
        part3: 'finale e irreversibile',
        part4: 'Nota: se sei iscritto tramite iTunes, l\'eliminazione del tuo account non ti cancellerà.',
        part5: 'Segui questo link per aiutarti a cancellarti da iTunes'
    }
  },
  promoTuto: {
    line1: 'Come utilizzare il vostro promocode " COMMUNITY "?',
    line2: '40 GIORNI DI PROVA GRATUITA',
    step1: "Scegliete una delle seguenti offerte",
    step2: 'Clicca su abbonati',
    step3: 'Clicca su "Ho un promocode" (presente solo in caso di prima iscrizione)',
    step4: 'Inserisci il tuo promocode: COMMUNITY',
    step51: 'Annullare in qualsiasi momento prima della fine del processo',
    step52: 'da non fatturare',
    step53: "se non vuoi continuare",
    warning: "Attenzione: Offerta valida solo alla prima registrazione"
  },
  premium: {
    authenticatePayment: "Autenticare il pagamento",
    seeInvoice: "Risolvere il problema",
    premiumUnlocks: 'GOWOD Premium consente di accedere al test di mobilità mensile che consente di determinare l\'asse di mobilità più redditizio da migliorare, nonché a tutti i protocolli di mobilità PRE-WOD POST-WOD e Daily, configurati sul punto debole dell\'utente per consentirgli di progredire in modo efficiente.',
    premiumSlogan: 'Mobilità facile e personalizzata',
    point1: 'Migliora le prestazioni del tuo WOD',
    point2: 'Facilitare l\'acquisizione di una tecnica ottimale',
    point3: 'Ottimizza il tuo trasferimento di forza',
    point4: 'Accelera il recupero',
    point5: 'Ridurre il rischio di lesioni',
    freeTrial: '14 giorni di prova gratuita per la prima registrazione',
    monthly: 'Mensile',
    halfYearly: 'Semestrale',
    yearly: 'Annuale',
    subscribe: 'Abbonati',
    perMonth: 'mese',
    per6Months: '6 mesi',
    perYear: '/ anno',
    subscriptionFrom: 'Abbonato dal',
    pausedUntil: 'Abbonamento in pausa fino a quando',
    nextBilling: 'Prossima fatturazione',
    changePlan: 'Cambia piano',
    confirm: 'Confermare',
    reactivateSub: 'Riattivare l\'abbonamento',
    unpauseSub: 'Riprendere l\'abbonamento',
    unpauseText: 'Stai per riavviare il tuo abbonamento, riavvia l\'applicazione BUONO una volta fatto per riavere l\'accesso a BUONO Premium.',
    unpause: 'Riattiva',
    break: 'Potete prendervi una pausa.!',
    pauseFor: 'Metti in pausa il tuo account per:',
    oneMonth: '1 mese',
    twoMonths: '2 mesi',
    threeMonths: '3 mesi',
    pauseText: 'Non vi sarà addebitato alcun costo durante la vostra pausa, il vostro abbonamento e l\'accesso a GOWOD Premium riprenderà alla fine di questo periodo. Potete anche riprendere l\'abbonamento quando volete.',
    pauseSub: 'Sospendi il mio abbonamento',
    noThanks: 'No grazie, cancella l\'abbonamento',
    promocode: 'Codice promozionale',
    signupDate: 'Data di sottoscrizione',
    accessUntil: 'Accesso fino a',
    firstBilling: 'Prima fatturazione',
    currentPeriod: 'Periodo corrente',
    status: 'Stato',
    cancelAtEnd: 'Annullate alla fine del periodo in corso',
    changePlanTitle: "Cambia abbonamento",
    changePlanContent: "Se si è in un periodo di prova, questo sarà preservato e il nuovo piano sarà fatturato alla fine del periodo di prova.\nIn caso contrario, il vostro abbonamento cambierà immediatamente piano e vi verrà addebitato un importo proporzionale per il nuovo piano, tenendo conto della parte utilizzata del vecchio piano.",
    statuses: {
      active: 'Attivo',
      trialing: 'Periodo di prova in corso',
      past_due: 'Problema di pagamento',
      unpaid: 'Problema di pagamento',
      incomplete: 'Autenticazione necessaria'
    },
    updateCC: 'Aggiornare la carta di credito',
    updateModal: {
      title: 'Aggiornamento carta di credito',
      content: 'Si prega di inserire i dati della nuova carta:'
    },
    unsubscribe: 'Annullare l\'iscrizione',
    successModal: {
      title: "Abbonamento riuscito!",
      part1: "Congratulazioni, ora sei un membro GOWOD Premium!",
      part2: "Chiudete e riaprite la vostra app GOWOD in modo che il vostro accesso Premium sia preso in considerazione."
    },
    unsubModal: {
      title: 'Confermare l\'annullamento dell\'iscrizione',
      part1: 'Potresti prenderti un momento per aiutarci a migliorare dicendoci perché te ne vai?',
      mail: 'Se hai un problema puoi inviarci un\'e-mail direttamente a ',
      part2: 'Avrete accesso a GOWOD Premium fino alla fine del periodo impostato.',
      confirm: 'Confermare',
      reason1: "Non lo uso a sufficienza",
      reason2: "Troppo costoso",
      reason3: "Non e' abbastanza efficiente",
      reason4: "Altro",
      addon: "Vuoi condividere qualcosa? (Opzionale)"
    },
    storesModal: {
      title: 'Annullare l\'iscrizione attraverso les app stores',
      part1: 'Sembra che l\'iscrizione a GOWOD Premium sia stata effettuata attraverso un app store.',
      part2: 'È possibile annullare l\'iscrizione alla tenda da sole corrispondente alla propria piattaforma.',
      part3: 'È possibile controllare questi collegamenti se si ha bisogno di aiuto:',
    },
    subscribeModal: {
      title: 'Abbonamento al GOWOD Premium',
      havePromocode: 'Ho un codice promozionale',
      validate: 'Convalidare',
      invalidCode: 'Codice non valido',
      validCode1: 'Codice valido',
      validCode2: 'giorni di prova'
    },
    promocodeModal: {
      link: "Ho un codice promozionale",
      title: "Utilizzo di un codice promozionale",
      intro: "I codici promozionali consentono di prolungare il periodo di prova dell'abbonamento GOWOD Premium",
      intro2: "Possono essere utilizzati solo al primo abbonamento",
      step1: "Scegliere la fatturazione desiderata (mensile o semestrale) e fare clic sul pulsante corrispondente",
      step2: "Si apre il pop-up di registrazione e se questo è il tuo primo abbonamento, attiva lo switch del codice promozionale",
      step3: "Inserisci il tuo codice nel campo e convalidalo con il pulsante",
      step4: "Se il tuo codice è valido vedrai un messaggio di convalida che conferma la durata del periodo di prova",
      step5: "Ora puoi inserire i tuoi dati di pagamento e continuare la tua registrazione"
    }
  },
  messages: {
    welcome: 'Benvenuto {{firstname}}',
    error: 'Si è verificato un errore',
    updateOK: 'Aggiornato con successo!',
    updateKO: 'Si è verificato un errore durante l\'aggiornamento del profilo',
    subscribeOK: 'La registrazione a GOWOD Premium è avvenuta con successo!',
    subscribeKO: 'Si è verificato un errore durante la registrazione al premio',
    cardInvalid: 'Carta non valida',
    cardUpdateOK: 'Aggiornamento delle mappe riuscito',
    cardUpdateKO: 'Si è verificato un errore durante l\'aggiornamento della mappa',
    cancelOK: 'Annullare l\'abbonamento con successo',
    cancelKO: 'Si è verificato un errore durante la cancellazione dell\'abbonamento',
    premiumInfoKO: 'Si è verificato un errore durante il recupero delle informazioni sui premi',
    deleteKO: 'Si è verificato un errore durante il recupero dei dati personali',
    pdataKO: 'Si è verificato un errore durante l\'eliminazione dell\'account',
    wrongCardData: 'Dati della carta non validi',
    resetOK: 'Password temporanea inviata',
    pauseOK: 'Abbonamento in pausa',

  },
  giftCards: {
    noiTunes: 'El código de regalo tiene la forma XXXX-XXXX-XXXX, ten en cuenta que si te registras a través de iTunes o Google Play, el código no tendrá ningún efecto. <br/>Per conoscere la procedura per passare da iTunes al nostro sito web, inviare un\'e-mail a <strong style="color:#6499FF">help@gowod.eu</strong>',
    enterCode: 'Para utilizar su tarjeta de regalo, por favor, introduzca el código:',
    successMessage: 'Su gato de regalo ha sido aplicado! Reinicia la aplicación y ya deberías tener acceso a GOWOD Premium.',
    redeem: 'Aplique'
  }
}


// WEBPACK FOOTER //
// ./src/languages/it.js